// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manual-reply-pause-section {
  margin-top: 8px;
  padding-top: 4px;
  padding-bottom: 8px;
  border-top: 1px solid #dedede;
}

.manual-reply-pause-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 10px 0 4px;
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ManualReplyPauseSetting.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".manual-reply-pause-section {\r\n  margin-top: 8px;\r\n  padding-top: 4px;\r\n  padding-bottom: 8px;\r\n  border-top: 1px solid #dedede;\r\n}\r\n\r\n.manual-reply-pause-label {\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  color: #777;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  padding: 10px 0 4px;\r\n  margin-bottom: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
